import script from "./RegisterUnmanagedBusinessModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterUnmanagedBusinessModal.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterUnmanagedBusinessModal.vue?vue&type=style&index=0&id=b8d48c8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d48c8e"]])

export default __exports__